
// object store name
export const OBJECTSTORE_CUSTOMERS = "Customers";
export const OBJECTSTORE_CUSTOMER_PROJECTS = "CustomerProjects";
